import Swiper from 'swiper';
import { Scrollbar } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/scrollbar';

const VISIBLE_RATIO = 0.7;

const updateVisibility = (swiper) => {
  const containerRect = swiper.el.getBoundingClientRect();
  swiper.slides.forEach((slide) => {
    const rect = slide.getBoundingClientRect();
    const visibleWidth =
      Math.min(rect.right, containerRect.right) - Math.max(rect.left, containerRect.left);
    const ratio = rect.width > 0 ? Math.max(0, visibleWidth) / rect.width : 0;
    slide.classList.toggle('is-visible', ratio >= VISIBLE_RATIO);
  });
};

export const initEventsCarousel = () => {
  const el = document.querySelector('.events__slider');
  if (!el) return;

  new Swiper(el, {
    modules: [Scrollbar],
    slidesPerView: 'auto',
    spaceBetween: 16,
    grabCursor: true,
    scrollbar: {
      el: '.events__scrollbar',
      draggable: true,
    },
    on: {
      init: updateVisibility,
      setTranslate: updateVisibility,
      transitionEnd: updateVisibility,
      touchMove: updateVisibility,
      resize: updateVisibility,
    },
  });
};
